import styled from "styled-components";

import { COLORS, FONTS, FONT_SIZE, FONT_WEIGHT } from "../../constants/Styles";
import Link from "next/link";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${COLORS.secondaryLight};
  width: 100%;
  margin-bottom: 2rem;

  > button {
    width: 328px;
  }
`;

export const UploadFileFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${COLORS.secondaryLight};
  width: 100%;
  margin-bottom: 2rem;
  gap: 1rem;
  > button {
    width: 328px;
  }
`;

export const SelectProgram = styled.div`
  margin: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const PickerText = styled.div`
  color: ${COLORS.secondary};
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight500};
  text-align: center;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

export const DocsLink = styled(Link)`
  font-size: ${FONT_SIZE.size14};
  margin-bottom: 2rem;
`;

export const GerberFileFormTitle = styled.div`
  color: ${COLORS.secondary};
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size18};
  text-align: center;
`;

export const GerberFileForm = styled.div`
  width: 100%;
  padding: 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FieldGroupNote = styled.div`
  font-size: ${FONT_SIZE.size12};
  text-align: center;
`;
